var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisibilityOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 6.32007C8.10043 6.32007 4.65043 8.55007 3.19043 12.0001C4.65043 15.4501 8.10043 17.6801 12.0004 17.6801C15.9004 17.6801 19.3504 15.4501 20.8104 12.0001C19.3504 8.55007 15.9004 6.32007 12.0004 6.32007ZM12.0004 16.4601C8.84043 16.4601 6.02043 14.7801 4.63043 12.0701L4.59043 11.9901L4.63043 11.9101C6.02043 9.21007 8.84043 7.52007 12.0004 7.52007C15.1604 7.52007 17.9804 9.20007 19.3704 11.9101L19.4104 11.9901L19.3704 12.0701C17.9804 14.7801 15.1504 16.4601 12.0004 16.4601Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0006 8.86011C10.2606 8.86011 8.85059 10.2701 8.85059 12.0001C8.86059 13.7401 10.2706 15.1401 12.0006 15.1401C13.7406 15.1401 15.1506 13.7301 15.1506 12.0001C15.1506 10.2701 13.7406 8.86011 12.0006 8.86011ZM12.0006 14.1101C10.8406 14.1101 9.89059 13.1601 9.89059 12.0001C9.89059 10.8401 10.8406 9.89011 12.0006 9.89011C13.1606 9.89011 14.1106 10.8401 14.1106 12.0001C14.1106 13.1701 13.1606 14.1101 12.0006 14.1101Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOn);
export default __webpack_public_path__ + "static/media/visibility-on.33f74e99.svg";
export { ForwardRef as ReactComponent };